import { memo } from 'react'
import { Box } from '@mui/material'
import { Position } from '../../proto/generated/position'
import PositionsTable from './positionsTable'
import EmptyView from '../postionsWidget/EmptyView'

export type PositionsTableScrollAreaProps = {
    positions: Position[]
    showGreeks: boolean
}

const PositionsTableScrollArea: React.FC<PositionsTableScrollAreaProps> = ({ positions, showGreeks }) => {
    if (positions.length === 0) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    py: 0,
                }}
            >
                <EmptyView text="Your intraday and carry-forward positions will appear here" />
            </Box>
        )
    }

    return (
        <Box sx={{ overflowX: 'auto', width: '100%', height: '100%' }}>
            <PositionsTable positions={positions} showGreeks={showGreeks} />
        </Box>
    )
}

export default memo(
    PositionsTableScrollArea,
    (prev, next) => prev.positions === next.positions && prev.showGreeks === next.showGreeks
)
